import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export const useMobileNavigation = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(
    // close mobile navigation when route changes
    () => setOpen(false),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname]
  );

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  return {
    handleOpen,
    handleClose,
    open
  };
};
